import React, { useEffect, useState, useRef } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { io } from "socket.io-client"
import Helpers from "../../../Helpers/Helpers"
import Breadcrum from "../../components/Breadcrum"
import { useProfile } from "../../context/ProfileContext"
import FullPageLoader from "../../components/FullPageLoader"
import Swal from 'sweetalert2'
import Notification from '../../../Helpers/Notification'
import { useCallback } from "react";
import { useOnBeforeUnload } from "../../../Helpers/Helpers";



const ChatComponent = ({ title }) => {
    // Load dedicated chat styles
    useEffect(() => {
        const chatStyleLink = document.createElement('link');
        chatStyleLink.rel = 'stylesheet';
        chatStyleLink.href = '/assets/css/chat.css';
        chatStyleLink.id = 'chat-styles';
        document.head.appendChild(chatStyleLink);

        // Cleanup function to remove the stylesheet when component unmounts
        return () => {
            const existingLink = document.getElementById('chat-styles');
            if (existingLink) {
                document.head.removeChild(existingLink);
            }
        };
    }, []);

    const { id } = useParams()
    const helpers = Helpers()
    const userProfile = useProfile()
    const { refreshUserProfile } = userProfile
    const navigate = useNavigate()
    const { search } = useLocation()

    const [messages, setMessages] = useState([]) // Start with an empty message array
    const [newMessage, setNewMessage] = useState("")
    const messagesEndRef = useRef(null)
    const socket = useRef(null) // Use a ref to store the socket instance
    const [isTyping, setIsTyping] = useState(false)
    const [astrologer, setAstrologer] = useState({})
    const [loading, setLoading] = useState(false)
    const [initiate, setInitiate] = useState(false)
    const [isBusy, setIsBusy] = useState(true)
    const [chatSession, setChatSession] = useState({})
    const [status, setStatus] = useState('pending')
    const [showRatingModal, setShowRatingModal] = useState(false); // Modal state
    const [rating, setRating] = useState(0);
    const [review, setReview] = useState("");
    const [ratingError, setRatingError] = useState(""); // Add error state for rating validation
    
    // Enhanced chat features state
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [onlineStatus, setOnlineStatus] = useState('online');
    const [lastSeen, setLastSeen] = useState('');
    const [astrologerTyping, setAstrologerTyping] = useState(false);
    const [currentTheme, setCurrentTheme] = useState('dark');
    const inputRef = useRef(null);
    const emojiPickerRef = useRef(null);

    // Emoji categories
    const emojiCategories = {
        recent: ['😊', '❤️', '👍', '🙏', '😢', '😂', '🔥', '✨'],
        smileys: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳'],
        hearts: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🤎', '🖤', '🤍', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟'],
        hands: ['👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '👊', '✊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏'],
        objects: ['⚡', '🔥', '✨', '💫', '⭐', '🌟', '💥', '💢', '��', '💨', '🕳️', '💣', '💬', '👁️‍🗨️', '🗨️', '🗯️', '💭', '💤'],
        astrology: ['🔮', '⭐', '🌟', '💫', '🙏', '✨', '🌙', '☀️', '🌞', '🌛', '🌜', '🌚', '🌕', '🌖', '🌗', '🌘', '🌑', '🌒', '🌓', '🌔']
    };

    const [activeEmojiCategory, setActiveEmojiCategory] = useState('recent');

    // Theme toggle function
    const toggleTheme = () => {
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
        setCurrentTheme(newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
    };

    // Initialize theme on component mount
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', currentTheme);
    }, []);

    // GET ASTROLOGER INFO
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                const response = await helpers.httpRequest(`/chat/${id}`, 'GET')
                // console.log(response);
                console.log('response', response);
                if (response.status === 'success') {
                    setAstrologer(response.data)
                    setChatSession(response.data)
                    setStatus(response.data.status)
                    // setIsBusy(response.data.isBusy && response.data.isBusy.userId !== userProfile.userInfo.id);

                } else {
                    navigate('/astrologer')
                }
            } catch (error) {
                console.error('Error fetching Astrologers:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    // Initialize Socket.IO client
    useEffect(() => {
        socket.current = io(process.env.REACT_APP_API_URL, {
            auth: {
                token: helpers.getStorage('accessToken') // Retrieve token from local storage or another source
            }
        })

        // Listen for incoming messages
        socket.current.on("sendMessage", (data) => {
            console.log(data);

            const message = createMessageWithStatus(
                data.content,
                "Assistant",
                data.timestamp || new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            );
            setMessages((prev) => [...prev, message])
        })

        socket.current.on("sendTyping", (data) => {
            setIsTyping(data.message)
        })

        socket.current.on("astrologerAcceptChat", (data) => {
            setStatus(data.chat_id == id && 'accepted')

        })

        socket.current.on("error", (data) => {
            if (data && data?.msg == 'Astrologer is busy!') {
                setIsBusy(true)
            }
            console.log(data);

        })


        // Add listener for 'sessionEnded' event
        socket.current.on('serverClosedChat', async (data) => {
            const status  = data?.status || 'error';
            const reason = data?.message || data?.reason || 'Something wants wrong';
            Notification(status, reason);
            
            // Refresh user data when chat is closed by server or any other method
            try {
                console.log('Chat closed by server - refreshing user data...');
                const updatedUserData = await helpers.refreshUserData();
                if (updatedUserData) {
                    console.log('User data refreshed successfully after server close');
                    // Update profile context as well
                    if (refreshUserProfile) {
                        await refreshUserProfile();
                    }
                } else {
                    console.warn('Failed to refresh user data after server close');
                }
            } catch (error) {
                console.error('Error refreshing user data after server close:', error);
            }
            
            socket.current.disconnect()
        });

        socket.current.onAny((event, ...args) => {
            console.log('Event received:', event, args);
        });


        const handleOnBeforeUnload = (e) => {
            // Use the browser's native confirmation dialog
            e.preventDefault();
            e.returnValue = "Are you sure you want to leave? Your chat session may be interrupted.";
            // This text may not be displayed in modern browsers
        };

        const handleOnUnload = async () => {
            if (socket.current) {
                try {
                    console.log('Browser closing/refreshing - updating wallet balance...');
                    
                    // Emit socket event to notify server
                    socket.current.emit("closedOrRefreshBrowser", {
                        chatId: id,
                        userId: userProfile?.userInfo?.id,
                        reason: "The user closed the browser or refreshed the page.",
                    });
                    
                    // Update wallet balance by getting fresh user data
                    const updatedUserData = await helpers.refreshUserData();
                    if (updatedUserData) {
                        console.log('Wallet balance updated on browser close:', {
                            oldBalance: userProfile.userInfo?.wallet_balance,
                            newBalance: updatedUserData.wallet_balance
                        });
                        
                        // Also update profile context if available
                        if (refreshUserProfile) {
                            await refreshUserProfile();
                        }
                    } else {
                        console.warn('Failed to update wallet balance on browser close');
                    }
                    
                    socket.current.disconnect();
                } catch (error) {
                    console.error('Error handling browser close:', error);
                    // Still try to disconnect socket
                    if (socket.current) {
                        socket.current.disconnect();
                    }
                }
            }
            Notification('error', 'The chat session has ended due to a refresh. To continue, please reconnect.')
        };

        // Attach events
        window.addEventListener("beforeunload", handleOnBeforeUnload);
        window.addEventListener("unload", handleOnUnload);

        // Clean up socket connection on component unmount
        return () => {
            window.removeEventListener("beforeunload", handleOnBeforeUnload);
            window.removeEventListener("unload", handleOnUnload);
        }
    }, [id, helpers])

    useEffect(() => {
        if (messagesEndRef && messagesEndRef.current) {
            const element = messagesEndRef.current
            element.scroll({
                top: element.scrollHeight,
                left: 0,
                behavior: "smooth"
            })
        }
    }, [messages, isTyping])


    useEffect(() => {
        setTimeout(() => {
            initiateChat();
        }, 3000);
    }, [chatSession]);  // Now re-runs when chatSession updates
    
    const initiateChat = useCallback(() => {
        socket.current.emit("initiateChat", { 
            chatSession, 
            user: { name: userProfile.userInfo.name, id: userProfile.userInfo.id }, 
            astrologer: chatSession.astrologerDetails 
        });
    }, [chatSession]);

    // Enhanced chat functions
    const handleEmojiSelect = (emoji) => {
        setNewMessage(prev => prev + emoji);
        // Add to recent emojis
        const recent = emojiCategories.recent;
        if (!recent.includes(emoji)) {
            emojiCategories.recent = [emoji, ...recent.slice(0, 7)];
        }
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const toggleEmojiPicker = () => {
        setShowEmojiPicker(!showEmojiPicker);
    };

    // Close emoji picker when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                setShowEmojiPicker(false);
            }
        };

        if (showEmojiPicker) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showEmojiPicker]);

    // Enhanced message with delivery status
    const createMessageWithStatus = (content, sender, timestamp) => {
        return {
            content,
            sender,
            timestamp,
            status: sender === 'You' ? 'sent' : 'received', // sent, delivered, read
            id: Date.now() + Math.random()
        };
    };

    // Update message status
    const updateMessageStatus = (messageId, status) => {
        setMessages(prev => prev.map(msg => 
            msg.id === messageId ? { ...msg, status } : msg
        ));
    };

    // Simulate message delivery status updates
    const simulateDeliveryStatus = (messageId) => {
        // Simulate delivered status after 1 second
        setTimeout(() => {
            updateMessageStatus(messageId, 'delivered');
        }, 1000);

        // Simulate read status after 3 seconds
        setTimeout(() => {
            updateMessageStatus(messageId, 'read');
        }, 3000);
    };

    // Enhanced typing indicator
    useEffect(() => {
        socket.current?.on("sendTyping", (data) => {
            setAstrologerTyping(data.message);
            // Auto-hide typing indicator after 3 seconds
            setTimeout(() => {
                setAstrologerTyping(false);
            }, 3000);
        });

        return () => {
            socket.current?.off("sendTyping");
        };
    }, []);

    // Online status simulation
    useEffect(() => {
        if (chatSession?.astrologerDetails) {
            setOnlineStatus('online');
            setLastSeen('');
        }
    }, [chatSession]);

    // Auto-scroll with smooth animation
    const scrollToBottom = () => {
        if (messagesEndRef?.current) {
            messagesEndRef.current.scrollIntoView({ 
                behavior: 'smooth',
                block: 'end'
            });
        }
    };

    // Enhanced scroll behavior
    useEffect(() => {
        scrollToBottom();
    }, [messages, astrologerTyping]);

    const handleSendMessage = async () => {
        if (!newMessage.trim()) return

        const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const message = createMessageWithStatus(newMessage, 'You', timestamp);
        
        // Add the new message to the chat immediately
        setMessages((prev) => [...prev, message])
        setNewMessage("")
        setShowEmojiPicker(false); // Close emoji picker
        handleTyping('')
        setIsTyping(false)

        try {
            // Emit the message to the server
            socket.current.emit("receiveMessage", { 
                message: {
                    content: message.content,
                    sender: 'You',
                    send_to: chatSession.astrologerId,
                    timestamp: message.timestamp
                }
            })
            console.log("receiveMessage from Astrologer");
            
            // Simulate delivery status updates
            simulateDeliveryStatus(message.id);
            
        } catch (error) {
            console.error('Error sending message:', error)
        }
    }

    const handleTyping = async (message) => {
        try {
            socket.current.emit("receiveTyping", { user_id: userProfile.userInfo.id, send_to: chatSession.astrologerId, message: message.length > 0 })
        } catch (error) {
            console.error('Error sending typing:', error)
        }
    }

    // // End session due to insufficient balance
    // useEffect(() => {
    //     if (socket?.current) {
    //         console.log('Listening for sessionEnded event...');

    //         // Add listener for 'sessionEnded' event
    //         socket.current.on('sessionEnded', (data) => {
    //             console.log('sessionEnded event received:', data);
    //             alert(`Chat ended: ${data.reason}`); // Fixed string interpolation
    //         });

    //         // Cleanup on component unmount
    //         return () => {
    //             console.log('Cleaning up sessionEnded listener...');
    //             socket.current.off('sessionEnded');
    //         };
    //     }
    // }, [socket]); // Dependency on `socket` instead of `socket?.current`





    const handleEndSession = async () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to close the chat!",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, close it!",
            customClass: {
                confirmButton: 'small-button',
                cancelButton: 'small-button'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    console.log('socket.current', socket);
                    // Step 1: Capture wallet balance IMMEDIATELY before any async operations
                    const currentWalletBalance = socket.current?.data?.wallet_balance;
                    console.log('currentWalletBalance', userProfile.userInfo);
                    console.log('chatSession', chatSession);
                    // Step 2: Update local storage synchronously FIRST
                    if (currentWalletBalance !== undefined) {
                        helpers.setStorage('wallet_balance', currentWalletBalance);
                        console.log('Updated wallet balance in localStorage:', currentWalletBalance);
                    } else {
                        console.warn('Wallet balance not available in socket data');
                    }

                    // Step 3: Make API call synchronously (wait for completion)
                    const response = await helpers.httpRequest(`/chat/update/${id}`, 'POST', { status: 'completed' });
                    
                    if (response.status !== 'success') {
                        throw new Error('Failed to update chat status');
                    }
                    
                    setStatus('completed');

                    // Step 4: Only emit socket event after all previous steps succeed
                    if (socket.current && socket.current.connected) {
                        socket.current.emit("userClosedChat", { 
                            user_id: userProfile.userInfo.id, 
                            send_to: chatSession.astrologerId, 
                            chat_id: chatSession._id 
                        });
                        console.log('Successfully emitted userClosedChat event');
                    } else {
                        console.warn('Socket not connected, cannot emit userClosedChat event');
                    }

                    // Step 5: Refresh user data to update wallet balance and profile
                    console.log('Chat ended by user - refreshing wallet balance...');
                    try {
                        const updatedUserData = await refreshUserProfile();
                        if (updatedUserData) {
                            console.log('Wallet balance updated after chat end:', {
                                oldBalance: userProfile.userInfo?.wallet_balance,
                                newBalance: updatedUserData.wallet_balance
                            });
                        }
                    } catch (error) {
                        console.error('Error refreshing user data after chat end:', error);
                    }

                    // Step 6: Show rating modal only after all operations complete
                    setTimeout(() => {
                        setShowRatingModal(true);
                    }, 1000);

                } catch (error) {
                    console.error("Error closing chat:", error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to close the chat.",
                        icon: "error"
                    });
                }
            }
        });
    };


    const handleSubmitRating = async () => {
        // Validate rating selection
        if (rating === 0) {
            setRatingError("Please select at least one star to submit your rating.");
            return;
        }
        
        // Clear error if validation passes
        setRatingError("");
        
        try {
            const payload = {
                entityId: chatSession.astrologerId, // Astrologer ID
                entityType: "astrologer",
                userId: userProfile.userInfo.id, // User ID
                rating,
                review,
            };

            const response = await helpers.httpRequest("/ratings", "POST", payload);
            if (response.status === "success") {
                Swal.fire({
                    title: "Thank you!",
                    text: response.message,
                    icon: "success",
                });
                setShowRatingModal(false); // Close modal
                // Reset rating states
                setRating(0);
                setReview("");
                setRatingError("");
            }
        } catch (error) {
            console.error("Error submitting rating:", error);
            Swal.fire({
                title: "Error!",
                text: "Failed to submit the rating.",
                icon: "error",
            });
        }
    };

    // Handle star rating click
    const handleStarClick = (starValue) => {
        setRating(starValue);
        setRatingError(""); // Clear error when user selects a rating
    };

    useEffect(() => {
        console.log("showRatingModal changed:", showRatingModal);
    }, [showRatingModal]);

    // Function to handle chat session end and update wallet balance
    const handleChatSessionEnd = async (reason = 'Chat session ended') => {
        try {
            console.log('Chat session ending - updating wallet balance...');
            
            // First try to get updated user data from API
            const updatedUserData = await helpers.refreshUserData();
            
            if (updatedUserData) {
                console.log('User data refreshed successfully:', {
                    oldBalance: userProfile.userInfo?.wallet_balance,
                    newBalance: updatedUserData.wallet_balance
                });
                
                // Update profile context to reflect changes immediately
                if (refreshUserProfile) {
                    await refreshUserProfile();
                }
                
                console.log('Wallet balance updated successfully');
            } else {
                console.warn('Failed to refresh user data - wallet balance may not be current');
            }
        } catch (error) {
            console.error('Error updating wallet balance after chat end:', error);
        }
    };

    return (
        <>
            {loading && <FullPageLoader />}
            <section className="chat_wrapper">
                {/* Theme Toggle Button */}
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            {
                                status === 'completed' ? (
                                    <div className="chat-ended-container">
                                        <div className="chat-ended-particles">
                                            {Array.from({length: 20}).map((_, i) => (
                                                <div 
                                                    key={i} 
                                                    className="particle" 
                                                    style={{
                                                        left: `${Math.random() * 100}%`,
                                                        animationDelay: `${Math.random() * 6}s`,
                                                        animationDuration: `${4 + Math.random() * 4}s`
                                                    }}
                                                />
                                            ))}
                                        </div>
                                        <div className="chat-ended-message">
                                            <div className="chat-ended-icon">✨</div>
                                            <h1 className="chat-ended-title">Chat Session Completed!</h1>
                                            <p className="chat-ended-subtitle">
                                                Thank you for your time. We hope you had a great experience with our astrology consultation.
                                            </p>
                                            <div className="chat-ended-actions">
                                                <button 
                                                    className="chat-ended-btn primary"
                                                    onClick={() => navigate('/astrologer')}
                                                >
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px'}}>
                                                        <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
                                                    </svg>
                                                    Chat Again
                                                </button>
                                                <button 
                                                    className="chat-ended-btn secondary"
                                                    onClick={() => navigate('/')}
                                                >
                                                    🏠 Go Home
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="chat_area">
                                        <div className="chat_header">
                                            <div className="chat_header_left">
                                                <div className="chat_partner_avatar">
                                                    <img src={chatSession?.astrologerDetails?.full_profile_pic} alt={chatSession?.astrologerDetails?.name} className="chat_partner_image" />
                                                    <div className={`online_status ${onlineStatus}`}></div>
                                                </div>
                                                <div className="chat_partner_info">
                                                    <b className="chat_partner_name">{chatSession?.astrologerDetails?.name}</b>
                                                    <div className="chat_partner_status">
                                                        {onlineStatus === 'online' ? (
                                                            <span className="status_text online">Online</span>
                                                        ) : (
                                                            <span className="status_text offline">Last seen {lastSeen}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat_header_right">
                                                <button 
                                                    className="header-theme-toggle" 
                                                    onClick={toggleTheme}
                                                    title={`Switch to ${currentTheme === 'dark' ? 'light' : 'dark'} theme`}
                                                >
                                                    <i className={`fas ${currentTheme === 'dark' ? 'fa-sun' : 'fa-moon'}`}></i>
                                                    <span>{currentTheme === 'dark' ? 'Light' : 'Dark'}</span>
                                                </button>
                                                <button className="btn btn-danger" onClick={() => handleEndSession()}>Close Chat</button>
                                            </div>
                                        </div>


                                        {/* Messages container */}
                                        <div className="messages" ref={messagesEndRef}>
                                            {messages.map((msg, index) => (
                                                <div key={msg.id || index} className={`message ${msg.sender === 'You' ? 'sent' : 'received'} fade-in`}>
                                                    <span className="content">{msg.content}</span>
                                                    <div className="message_footer">
                                                        <span className="timestamp">{msg.timestamp}</span>
                                                        {msg.sender === 'You' && (
                                                            <div className="delivery_status">
                                                                {msg.status === 'sent' && <span className="status_icon">✓</span>}
                                                                {msg.status === 'delivered' && <span className="status_icon delivered">✓✓</span>}
                                                                {msg.status === 'read' && <span className="status_icon read">✓✓</span>}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            {/* Enhanced typing animation */}
                                            {(isTyping || astrologerTyping) && (
                                                <div className="typing-indicator">
                                                    <div className="typing_avatar">
                                                        <img src={chatSession?.astrologerDetails?.full_profile_pic} alt="typing" className="typing_image" />
                                                    </div>
                                                    <div className="typing_bubble">
                                                        <span className="dot"></span>
                                                        <span className="dot"></span>
                                                        <span className="dot"></span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {
                                            status === 'pending' ? (
                                                <div className="pending-chat-message">
                                                    <h3>Chat will start once the Astrologer accepts, wait...</h3>
                                                    <div className="loading-crystal"></div>
                                                </div>
                                            ) : (
                                                <div className="message_input_wrapper">
                                                    <div className="message_input">
                                                        <button 
                                                            className="emoji_button"
                                                            onClick={toggleEmojiPicker}
                                                            type="button"
                                                        >
                                                            😊
                                                        </button>
                                                        <input
                                                            ref={inputRef}
                                                            type="text"
                                                            placeholder="Type a message..."
                                                            value={newMessage}
                                                            onChange={(e) => setNewMessage(e.target.value)}
                                                            onKeyUp={(e) => {
                                                                handleTyping(e.target.value);
                                                                if (e.key === 'Enter') {
                                                                    handleSendMessage();
                                                                }
                                                            }}
                                                            className="message_input_field"
                                                        />
                                                        <button 
                                                            onClick={handleSendMessage}
                                                            className="send_button"
                                                            disabled={!newMessage.trim()}
                                                        >
                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    
                                                    {/* Emoji Picker */}
                                                    {showEmojiPicker && (
                                                        <div className="emoji_picker" ref={emojiPickerRef}>
                                                            <div className="emoji_categories">
                                                                {Object.keys(emojiCategories).map(category => (
                                                                    <button
                                                                        key={category}
                                                                        className={`emoji_category ${activeEmojiCategory === category ? 'active' : ''}`}
                                                                        onClick={() => setActiveEmojiCategory(category)}
                                                                    >
                                                                        {category === 'recent' && '🕒'}
                                                                        {category === 'smileys' && '😊'}
                                                                        {category === 'hearts' && '❤️'}
                                                                        {category === 'hands' && '👋'}
                                                                        {category === 'objects' && '⚡'}
                                                                        {category === 'astrology' && '🔮'}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                            <div className="emoji_grid">
                                                                {emojiCategories[activeEmojiCategory].map((emoji, index) => (
                                                                    <button
                                                                        key={index}
                                                                        className="emoji_item"
                                                                        onClick={() => handleEmojiSelect(emoji)}
                                                                    >
                                                                        {emoji}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    {/* Rating Modal */}
                    {showRatingModal && (
                        <div className={`modal-overlay ${showRatingModal ? "" : "modal-closing"}`}>

                            <div className="modal">
                                {/* Close Icon */}
                                <span
                                    className="modal-close-icon"
                                    onClick={() => setShowRatingModal(false)}
                                >
                                    &times;
                                </span>

                                {/* Astrologer Details */}
                                <img
                                    src={chatSession?.astrologerDetails?.full_profile_pic}
                                    alt={chatSession?.astrologerDetails?.name}
                                    className="chat_partner_rating_img"
                                />
                                <div>
                                    <b className="chat_partner_name">{chatSession?.astrologerDetails?.name}</b>
                                </div>

                                <p>Your feedback is valuable to us!</p>

                                {/* Rating Stars */}
                                <div className="rating-stars">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <span
                                            key={star}
                                            className={`star ${star <= rating ? 'filled' : ''}`}
                                            onClick={() => handleStarClick(star)}
                                        >
                                            ★
                                        </span>
                                    ))}
                                </div>

                                {/* Error Message */}
                                {ratingError && (
                                    <div className="rating-error">
                                        {ratingError}
                                    </div>
                                )}

                                {/* Review Input */}
                                <div className="review-input">
                                    <label htmlFor="review">Review:</label>
                                    <textarea
                                        id="review"
                                        value={review}
                                        onChange={(e) => setReview(e.target.value)}
                                        placeholder="Write your review here..."
                                    />
                                </div>

                                {/* Submit Button */}
                                <div className="modal-actions">
                                    <button className="btn-rating-submit btn-sm" onClick={handleSubmitRating}>
                                        <b>Submit</b>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}


                </div>
            </section>

        </>
    )
}

export default ChatComponent